<template>
  <div class="extension__form">
    <dynamic-form :fields="fields" :object="object" :typeForm="typeForm" v-if="typeForm && typeForm.structure"></dynamic-form>
    <standard-form :fields="fields" :object="object" v-else></standard-form>
  </div>
</template>

<script>
import StandardForm from '@/components/StandardForm';
import DynamicForm from '@/components/DynamicForm';

export default {
  props: ['object', 'fields'],
  components: {
    DynamicForm,
    StandardForm,
  },
  computed: {
    objectType() {
      return this.$route.params.type;
    },
    typeForm() {
      /* eslint-disable */
      return this.$store.getters['forms/getTypeForm'](this.objectType);
      /* eslint-enable */
    },
  },
  created() {
    this.$store.dispatch(`forms/get`);
  },
};
</script>
